import { ReactNode } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import FollowButton from 'src/components/buttons/followButton/followButton';
import { Section } from 'src/constants/footfall';
import { showLoginModal } from 'src/modules/shared/modal/actions';
import i18n from 'src/utils/translate';
import { LinkButton } from 'styles-js/buttons';
import { useIsLoggedIn } from 'src/utils/hooks/useIsLoggedIn';

export default function PrivatePostMessage({ children }: { children: ReactNode }) {
  const dispatch = useDispatch();
  const currentCommunity = useSelector(({ context }) => context.currentCommunity);
  const isLoggedIn = useIsLoggedIn();

  const onClick = () => {
    dispatch(showLoginModal({ clickMetaData: { section: Section.ConvBoxReply } }));
  };

  return (
    <Container>
      {children}
      <FollowButton
        buttonType="primary"
        clickMetadata={{ section: Section.ConvBoxReply }}
        community={currentCommunity}
        followText={i18n.t('Join now')}
        followType="community"
        hasIcon={false}
      />
      {!isLoggedIn && (
        <p>
          <LinkButton onClick={onClick}>
            {i18n.t('Already a member? Log in')}
          </LinkButton>
        </p>
      )}
    </Container>
  );
}

const Container = styled.div`
  text-align: center;
  padding: 20px 15px;
  background-color: ${({ theme }) => theme.colorBlueBackground};
  margin: 20px auto;

  p {
    margin: 10px 0;
  }
`;
